import script from "./MunicipalityForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./MunicipalityForm.vue?vue&type=script&lang=ts&setup=true"

import "./MunicipalityForm.vue?vue&type=style&index=0&id=8d974686&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d974686"]])

export default __exports__